import axios from 'axios';
import * as types from 'src/store/types';
import { getDiagnosisActionHistory, getDiagnosisConsumption, getDiagnosisSuggestion } from 'src/service/inspect';
import { getTodayByTimezone, getDate } from 'src/utils/dateUtil';
import moment from 'moment';
import _ from 'lodash';

const { CancelToken } = axios;

/** @type {Function} */
let cancelGetDiagnosisConsumption;
// const testId = '1700920852040726';
const INITIAL_STATE = {
  adGroupId: '',

  suggestionData: {},
  consumption: {
    cpc: {
      value: 1234234,
      percentage: -0.5,
    },
    convert: {
      value: 111234,
      percentage: 0.36,
    },
    cpa: {
      value: 199999,
      percentage: -0.5,
    },
    cpm: {
      value: 3456456,
      percentage: 0,
    },
    ctr: {
      value: 0.52,
      percentage: 0.5,
    },
    cost: {
      value: 345834953485,
      percentage: -0.5,
    },
  },

  actionsHistory: {
    actions: [],
    cost_conversion_trends: [],
  },
  adGroup: {},
  diagnosisLoading: true,
  smbFirstRequest: true,
  libraResult: true,
};

const diagnosis = {
  namespaced: true,
  state: _.cloneDeep(INITIAL_STATE),
  getters: {
    libraResultIsTrue(state) {
      return state.libraResult;
    },
  },
  mutations: {
    resetStore(state) {
      Object.assign(state, _.cloneDeep(INITIAL_STATE));
    },
    setSuggestionData(state, data) {
      state.suggestionData = data;
    },
    setAdGroup(state, data) {
      state.adGroup = data;
    },
    setLoading(state, value) {
      state.diagnosisLoading = value;
    },
    setConsumption(state, data) {
      state.consumption = data;
    },
    setActionsHistory(state, data) {
      state.actionsHistory = data;
    },
    [types.SET_SMB_FIRST_REQUEST](state, data) {
      state.smbFirstRequest = data;
    },
    [types.SET_LIBRA_RESULT](state, data) {
      state.libraResult = data;
    },
  },
  actions: {
    async reloadSuggestionData({ state, commit }) {
      try {
        commit('setLoading', true);
        const resp = await getDiagnosisSuggestion({ ad_id: state.adGroup.ad_id });
        if (resp?.data) commit('setSuggestionData', resp.data);
        commit('setLoading', false);
      } catch {
        commit('setLoading', false);
      }
    },
    async loadConsumptionData({ state, commit }) {
      cancelGetDiagnosisConsumption && cancelGetDiagnosisConsumption();
      const resp = await getDiagnosisConsumption({ ad_id: state.adGroup.ad_id }, {
        cancelToken: new CancelToken((c) => {
          cancelGetDiagnosisConsumption = c;
        }),
      });

      commit('setConsumption', resp.data);
    },
    async initDiagnosisData({ state, commit, dispatch }) {
      commit('setLoading', true);
      try {
        const resp = await Promise.all([
          getDiagnosisActionHistory({ ad_id: state.adGroup.ad_id }),
          getDiagnosisSuggestion({ ad_id: state.adGroup.ad_id }),
          dispatch('loadConsumptionData'),
        ]);
        const { cost_conversion_trends } = resp[0].data;
        const momentWithTZ = getDate();
        const accountToday = getTodayByTimezone();
        const daysList = [];
        for (let i = 0; i < 14; i++) {
          daysList.push(moment(accountToday)
            .subtract(i, 'days')
            .format('YYYY-MM-DD'));
        }
        daysList.reverse();
        const finalData = [];
        daysList.forEach((item) => {
          const index = cost_conversion_trends.findIndex(trend => item === momentWithTZ(Number(trend.timestamp))
            .format('YYYY-MM-DD'));
          if (index > -1) {
            finalData.push({
              ...cost_conversion_trends[index],
              date: item,
            });
          } else if (finalData.length === 0) {
            finalData.push({
              accumulate_conversion: 0,
              accumulate_cost: 0,
              daily_cost: 0,
              date: item,
            });
          } else {
            finalData.push({
              ...finalData[finalData.length - 1],
              date: item,
              daily_cost: 0,
            });
          }
        });
        commit('setActionsHistory', {
          ...resp[0].data,
          cost_conversion_trends: finalData,
        });
        commit('setSuggestionData', resp[1].data);
        commit('setLoading', false);
      } catch {
        commit('resetStore');
      }
    },
  },
};

export default diagnosis;
